import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

export interface AttendeeImportColumnMapping {
  // Each template column maps to a source header, an array of source headers, or null.
  mapping: { [templateColumn: string]: string | string[] | null };
  confidence: number | null;
  notes: string;
  mapped_count: number;
}

export interface AttendeeImportReformatResult {
  // One record per input row, keyed by the template columns.
  rows: { [templateColumn: string]: string }[];
  warnings: string[];
  guardedDropped: number;
}

@Injectable()
export class CoreEventAttendeeService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/attendees`);
  }

  // Bulk-create attendees from a parsed list.
  import(attendees: any[], urlParams: any = {}): Observable<any> {
    const url = `${sprintf(this.baseUrl, urlParams)}/import`;
    return this.http.post<any>(url, { attendees });
  }

  // POC: ask the backend AI to map an uploaded file's columns onto the import template.
  mapImportColumns(sourceHeaders: string[], sampleRows: any[]): Observable<AttendeeImportColumnMapping> {
    const url = `${environment.apiBaseUrl}/bedrock/attendee-import/map-columns`;
    return this.http.post<AttendeeImportColumnMapping>(url, { sourceHeaders, sampleRows });
  }

  // POC: ask the backend AI to clean AND reformat the raw rows (split/parse/standardize
  // values) into the given template columns.
  reformatImportRows(targetColumns: string[], rawRows: any[]): Observable<AttendeeImportReformatResult> {
    const url = `${environment.apiBaseUrl}/bedrock/attendee-import/reformat`;
    return this.http.post<AttendeeImportReformatResult>(url, { targetColumns, rawRows });
  }
}
